module.exports = __webpack_public_path__ + "img/v3-tile-view.82d5b413.svg";